import styled from 'styled-components'

const StepName = styled.div`
  font-weight: bold;
  width: 100%;
`

export default StepName